import { DOM_POINTER_TYPES } from '../../../../utils/domConstants';

class ActivePointerEventCache {
    // using an array here rather than map so we can easily get the first touch event
    eventCache: Array<number>;

    constructor() {
        this.eventCache = [];
    }

    getFirstPointerId() {
        return this.eventCache[0];
    }

    add(pointerEvent: PointerEvent) {
        this.eventCache.push(pointerEvent.pointerId);
    }

    remove(pointerEvent: PointerEvent) {
        const pointerIdIndex = this.eventCache.indexOf(pointerEvent.pointerId);
        if (pointerIdIndex > -1) {
            this.eventCache.splice(pointerIdIndex, 1);
        }
    }

    size() {
        return this.eventCache.length;
    }

    clear() {
        this.eventCache = [];
    }

    shouldRespondTo(event: PointerEvent) {
        // always respond to non-touch events
        if (event.pointerType !== DOM_POINTER_TYPES.TOUCH) return true;

        // for touch pointers, only respond to the first simultaneous pointer registered
        return event.pointerId === this.getFirstPointerId();
    }
}

export default ActivePointerEventCache;
